import React, { forwardRef, useEffect, useState } from 'react'

import { getWidgetInfo } from '@/utils/dynamicWidget.js'

export const ScrollingBanner = forwardRef(({ onVisibilityChange }, ref) => {
    const [isVisible, setIsVisible] = useState(false)
    const [src, setSrc] = useState('')

    useEffect(() => {
        async function checkStatus() {
            const widgetConfig = await getWidgetInfo('scrolling_banner')
            const status = widgetConfig?.find(
                item => item.key === 'status'
            )?.value
            const url = widgetConfig?.find(item => item.key === 'url')?.value

            if (status === 'on' && url) {
                setSrc(url)
                setIsVisible(true)
                onVisibilityChange?.(true) // Notify parent
            } else {
                setIsVisible(false)
                onVisibilityChange?.(false)
            }
        }
        checkStatus()
    }, [onVisibilityChange])

    if (!isVisible || !src) return null

    return (
        <div
            ref={ref}
            className="fixed top-0 z-[100001] w-full scrolling-banner"
        >
            <iframe
                src={src}
                title="Scrolling Banner"
                width="100%"
                height="50px"
                scrolling="no"
            ></iframe>
        </div>
    )
})

ScrollingBanner.displayName = 'ScrollingBanner'

export default ScrollingBanner
